import TableSettings from "../../../../components/Table/Settings"
import { ColumnLabel } from "../../../../components/Table/Settings/Toolbar";
import { Dialog } from "@rio-cloud/rio-uikit";
import { createSubCategories, deleteSubCategories, editSubCategories, getAllSubCategories } from "../../../../services/form";
import { useEffect, useState } from "react";
import { Notification } from '@rio-cloud/rio-uikit';
import DialogCreateSubCategorySetttings from "../../../../components/Dialog/CreateSubCategorySettings";
import DialogEditCategorySetttings from "../../../../components/Dialog/EditSubCategorySettings";

const defaultColumnOrder = ['categoryName', 'name'];

const columnLabels: ColumnLabel = {
  id: '1',
  categoryName: "Categoria",
  name: "Subcategoria",
  date: ''
};

interface IOptionsProps {
  id: number;
  name: string;
  date: string;
  categoryName: string;
  categoryId: number;
}

interface IOptionSelectedProps {
  id: number;
  name: string;
  categoryName?: string;
  categoryId?: number;
}

const SubCategoriesPage = () => {
  const [createNewModal, setCreateNewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [options, setOptions] = useState<IOptionsProps[]>([]);
  const [optionSelected, setOptionSelected] = useState<IOptionSelectedProps>();

  const mountOption = (data: any[]) => {
    return data?.map((res: { id: number; name: string, categoryName: string, categoryId: number }) => {
      return {
        id: res.id,
        categoryId: res.categoryId,
        name: res.name,
        categoryName: res?.categoryName,
        date: '',
      };
    });
  };
  
  const fetchOptions = async () => {
    try {
      const response = await getAllSubCategories();
      console.log(`response`, response)

      setOptions(mountOption(response.data));

    } catch (error) {
      console.log('error', error);
      setOptions([]);
    }
  }

  useEffect(() => {
    fetchOptions();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveNewOption = async (value: string, selectCategory?: string, selectType?: string) => {
    try {
       await createSubCategories(selectCategory || '', {name: value});
      fetchOptions();
      setCreateNewModal(false);
      Notification.success('Subcategoria criada com sucesso.');
    } catch (error) {
      Notification.error('Não foi possível criar a subcategoria no momento.')
    }
  }

  const handleEditOption = async (value: string) => {
    if(!optionSelected?.id) return

    try {
      await editSubCategories(String(optionSelected?.categoryId) || '', {id: optionSelected?.id, name: value});
      fetchOptions();
      setEditModal(false);
      Notification.success('Subcategoria alterada com sucesso.');
    } catch (error) {
      Notification.error('Não foi possível alterar a subcategoria no momento.')
    }
  }

  const handleDeleteOption = async (value: string) => {
    if(!optionSelected?.id) return
    try {
      await deleteSubCategories(optionSelected?.id)
      fetchOptions();
      setDeleteModal(false);
      Notification.success('Subcategoria deletada com sucesso.');
    } catch (error) {
      Notification.error('Não foi possível deletar a subcategoria no momento.')
    }
  }

  return (
    <>
      <TableSettings
        data={options}
        totalData={options.length}
        columnLabels={columnLabels}
        defaultColumnOrder={defaultColumnOrder}
        viewType="TABLE"
        onLoadMore={(res) => console.log(res)}
        handleRefresh={() => {}}
        handleDownload={() => console.log('DOWNLOAD')}
        openModal={() => {setCreateNewModal(true);}}
        onEdit={(id, name, type, expenseType, categoryName, categoryId) => {setOptionSelected({id, name, categoryName, categoryId}); setEditModal(true);}}
        onDelete={(id) => {setOptionSelected({id, name: ''}); setDeleteModal(true);}}
        onDeleteFile={() => {}}
        onGetFile={() => {}}
        onObservation={() => {}}
      />

      <DialogCreateSubCategorySetttings
        title='Nova subcategoria'
        show={createNewModal}
        placeholder='Qual o nome da nova subcategoria?'
        onClose={() => { setCreateNewModal(false); }}
        onSave={handleSaveNewOption}
      />

      <DialogEditCategorySetttings
        title='Editar subcategoria'
        show={editModal}
        placeholder='Qual o novo nome da subcategoria?'
        onClose={() => { setEditModal(false); }}
        onSave={(value: string) => handleEditOption(value)}
        name={optionSelected?.name}
      />

      <Dialog
        show={deleteModal}
        title={<span className='text-medium text-size-16'>Excluir categoria</span>}
        body={
          <div className='padding-20'>
            <p>Tem certeza que deseja excluir esta categoria?</p>
            <p className='text-color-danger'>Esta ação não pode ser desfeita.</p>
          </div>
        }
        footer={
          <div className='display-flex gap-10 justify-content-end'>
            <button
              className='btn btn-default'
              onClick={() => setDeleteModal(false)}
            >
              Cancelar
            </button>
            <button
              className='btn btn-danger'
              onClick={() => handleDeleteOption('')}
            >
              Excluir
            </button>
          </div>
        }
        onClose={() => setDeleteModal(false)}
        className='exampleDialog'
        showCloseButton
        bsSize='sm'
      />
    </>
  )
}

export default SubCategoriesPage